module.exports = __webpack_public_path__ + "img/lc_map01.bd1ad4f0.jpg";